import React from 'react';
import { useDispatch } from 'react-redux';
import CustomSingleSelect, { CustomSingleSelectModel } from '../../../../components/CustomSingleSelect';
import { storeActivityIndicator, storeFastFirm } from '../../../../redux/reducers/authSlice';
import { CompanyService } from '../../../../services/CompanyService';
import { ConstantService } from '../../../../services/ConstantService';
import { KTCard } from '../../../../_metronic/helpers/components/KTCard';
import { KTCardBody } from '../../../../_metronic/helpers/components/KTCardBody';
import toast from "react-hot-toast";
import { GetCompanyByIdResponse } from '../../../../models/response/company/GetCompanyByIdResponse';
import { DriverService } from '../../../../services/DriverService';
import { GetDriverByIdResponse } from '../../../../models/response/driver/GetDriverByIdResponse';
import { VehicleService } from '../../../../services/VehicleService';
import { GetVehicleByIdResponse } from '../../../../models/response/vehicle/GetVehicleByIdResponse';

interface Props {
    voyageInformationRef: any
    selectedVoyageStatus: CustomSingleSelectModel | undefined
    setSelectedVoyageStatus: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    voyageNo: string | undefined
    setVoyageNo: React.Dispatch<React.SetStateAction<string | undefined>>
    selectedVehicle: CustomSingleSelectModel | undefined
    setSelectedVehicle: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedTrailer: CustomSingleSelectModel | undefined
    setSelectedTrailer: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedDriver: CustomSingleSelectModel | undefined
    setSelectedDriver: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
    selectedSupplier: CustomSingleSelectModel | undefined
    setSelectedSupplier: React.Dispatch<React.SetStateAction<CustomSingleSelectModel | undefined>>
}

const VoyageInformation = ({
    voyageInformationRef,
    selectedVoyageStatus,
    setSelectedVoyageStatus,
    voyageNo,
    setVoyageNo,
    selectedVehicle,
    setSelectedVehicle,
    selectedTrailer,
    setSelectedTrailer,
    selectedDriver,
    setSelectedDriver,
    selectedSupplier,
    setSelectedSupplier,
}: Props) => {
    const dispatch = useDispatch();

    const onPlateChange = async (selectedValue: CustomSingleSelectModel | undefined) => {
        try {
            dispatch(storeActivityIndicator(true));
            if (selectedValue) {
                var response4: GetVehicleByIdResponse = await VehicleService.getVehicleById(selectedValue.value);

                if (!response4.isSuccess) {
                    toast.error(response4.message)
                    return;
                }

                var vehicle = response4.data;

                if (vehicle) {
                    if (vehicle.trailerId) {
                        var response3: GetVehicleByIdResponse = await VehicleService.getVehicleById(vehicle.trailerId);

                        if (!response3.isSuccess) {
                            toast.error(response3.message)
                            return;
                        }

                        var selectedTrailer = response3.data;

                        if (selectedTrailer)
                            setSelectedTrailer({ label: selectedTrailer.plate, value: selectedTrailer.vehicleId });
                        else
                            setSelectedTrailer(undefined)
                    }
                    else
                        setSelectedTrailer(undefined)

                    if (vehicle.driverId) {
                        var response2: GetDriverByIdResponse = await DriverService.getDriverById(vehicle?.driverId);

                        if (!response2.isSuccess) {
                            toast.error(response2.message)
                            return;
                        }

                        var selectedDriver = response2.data;

                        if (selectedDriver && selectedDriver.nameSurname && selectedDriver.driverId)
                            setSelectedDriver({ label: selectedDriver.nameSurname, value: selectedDriver.driverId });
                        else
                            setSelectedDriver(undefined)
                    }
                    else
                        setSelectedDriver(undefined)

                    if (vehicle.vehicleOwnerId) {
                        var response: GetCompanyByIdResponse = await CompanyService.getCompanyById(vehicle?.vehicleOwnerId);

                        if (!response.isSuccess) {
                            toast.error(response.message)
                            return;
                        }

                        var selectedSupplier = response.data;

                        if (selectedSupplier && selectedSupplier.name)
                            setSelectedSupplier({ label: selectedSupplier.name, value: selectedSupplier.companyId });
                        else
                            setSelectedSupplier(undefined)
                    }
                    else
                        setSelectedSupplier(undefined)
                }
                else {
                    setSelectedTrailer(undefined)
                    setSelectedDriver(undefined)
                    setSelectedSupplier(undefined)
                }
            }
            else {
                setSelectedTrailer(undefined)
                setSelectedDriver(undefined)
                setSelectedSupplier(undefined)
            }

            setSelectedVehicle(selectedValue);
        } catch (error: any) {
            toast.error(error)
        }
        finally {
            dispatch(storeActivityIndicator(false))
        }
    }

    return (
        <div className='containerPart' ref={voyageInformationRef}>
            <KTCard className="ebbe-card mt-10">
                <KTCardBody>
                    <h4 className="mb-10 text-black">Sefer Bilgileri</h4>

                    <div className='row'>
                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Sefer Durumu</label>

                                <CustomSingleSelect
                                    selectedValue={selectedVoyageStatus}
                                    onChange={setSelectedVoyageStatus}
                                    onMenuOpen={() => ConstantService.getConstantList('VOYAGE_STATUS', undefined, undefined)}
                                    labelName='value'
                                    valueName='constantId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Sefer No</label>

                                <input style={{ border: '1px solid #F1F1F4' }} value={voyageNo} onChange={(e) => setVoyageNo(e.target.value)} type="text" className="form-control form-control-solid" disabled />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Araç Plaka</label>

                                <CustomSingleSelect
                                    selectedValue={selectedVehicle}
                                    onChange={onPlateChange}
                                    onMenuOpen={() => VehicleService.getVehicleList(undefined, ["6", "7"])}
                                    labelName='plate'
                                    valueName='vehicleId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Treyler Plaka</label>

                                <CustomSingleSelect
                                    selectedValue={selectedTrailer}
                                    onChange={setSelectedTrailer}
                                    onMenuOpen={() => VehicleService.getVehicleList(["6", "7"])}
                                    labelName='plate'
                                    valueName='vehicleId'
                                />
                            </div>
                        </div>

                        <div className="col-md-4">
                            <div>
                                <label htmlFor="exampleFormControlInput1" className="form-label">Sürücü</label>

                                <CustomSingleSelect
                                    selectedValue={selectedDriver}
                                    onChange={setSelectedDriver}
                                    onMenuOpen={() => DriverService.getDriverList()}
                                    labelName='nameSurname'
                                    valueName='driverId'
                                />
                            </div>

                            <div className="mt-5">
                                <label htmlFor="exampleFormControlInput1" className="form-label">Tedarikçi</label>

                                <CustomSingleSelect
                                    selectedValue={selectedSupplier}
                                    onChange={setSelectedSupplier}
                                    insertable={{
                                        tooltipText: 'Firma seçilmeden basıldığında Yeni firma tanımlaması yapılmasını, firma seçimi yapıldıktan sonra basıldığında ise seçilen firmanın bilgilerinin Güncellenmesini sağlar.',
                                        onClick: () => {
                                            dispatch(storeFastFirm({
                                                companyId: selectedSupplier?.value,
                                                isSupplier: true,
                                                onSubmit: async (response) => {
                                                    setSelectedSupplier({ label: response.name, value: response.companyId })
                                                }
                                            }))
                                        }
                                    }}
                                    onMenuOpen={() => CompanyService.getCompanyList({ isSupplier: true })}
                                    labelName='name'
                                    valueName='companyId'
                                />
                            </div>
                        </div>
                    </div>
                </KTCardBody>
            </KTCard>
        </div>
    )
}

export default VoyageInformation;